import { Link } from 'react-router-dom';

export default function CanapesSection() {
  return (
    <section className="sec" data-testid="canapes-section">
      <p className="eyebrow rv">No solo gildas</p>
      <h2 className="D D-md rv" style={{ marginBottom: '2.5rem' }}>
        Canapés, tortilla y <em>producto local.</em>
      </h2>
      <div className="split col12">
        <div>
          <ul className="clist rv">
            <li><span className="cdot" /><div><div className="cname">Canapé de gambas <span className="badge-estrella">El más pedido</span></div><div className="cdesc">Pan de pueblo, gamba fresca, mahonesa de la casa y un toque de cebollino.</div></div></li>
            <li><span className="cdot" /><div><div className="cname">Canapé de anchoa</div><div className="cdesc">Anchoa de Santoña, mantequilla de la tierra y guindilla.</div></div></li>
            <li><span className="cdot" /><div><div className="cname">Canapé de bonito</div><div className="cdesc">Bonito del norte, pimiento confitado y oliva negra.</div></div></li>
            <li><span className="cdot" /><div><div className="cname">Tortilla casera <span className="badge-estrella">Cada día</span></div><div className="cdesc">Patata cántabra, huevo fresco. Hecha en casa cada mañana.</div></div></li>
            <li><span className="cdot" /><div><div className="cname">Toreras</div><div className="cdesc">El pincho legendario del Cabrero. Pregunta en barra.</div></div></li>
          </ul>
          <Link to="/galeria" className="btn btn-o rv" style={{ marginTop: '1.5rem' }}>Ver galería →</Link>
        </div>
        <div className="rv">
          <div className="fcard"><h4>Producto local, primero</h4><p>Anchoa de Santoña, patata cántabra, huevo fresco, blanco de la Nava. La tierra entra en la barra.</p></div>
          <div className="fcard"><h4>Sin atajos</h4><p>Nada precocinado. Todo se monta en casa, esa misma mañana, con manos que llevan décadas haciéndolo.</p></div>
          <div className="fcard"><h4>Para llevar</h4><p>¿Una bandeja de gildas para casa? Avísanos por WhatsApp y la preparamos.</p></div>
        </div>
      </div>
    </section>
  );
}
